// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"LoadProject_dropzone__6a5Ft","reject":"LoadProject_reject__1NjN5","accept":"LoadProject_accept__1a3qM","browse-button":"LoadProject_browse-button__Kvg8t"};